function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  opacity: 0.8
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#profiles-metric_svg__clip0_10117_30093)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 0.667,
  y: 6.462,
  width: 51.636,
  height: 51.636,
  rx: 25.818,
  fill: "#181C20"
}), /*#__PURE__*/React.createElement("g", {
  opacity: 0.5
}, /*#__PURE__*/React.createElement("path", {
  fill: "#272D33",
  d: "M.667 6.462h51.636v51.636H.667z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M37.242 25.826c0 5.941-4.816 10.758-10.757 10.758-5.942 0-10.758-4.817-10.758-10.758 0-5.941 4.816-10.758 10.758-10.758 5.94 0 10.757 4.817 10.757 10.758zM9.272 58.099c0-9.506 7.707-17.212 17.213-17.212s17.212 7.706 17.212 17.212H9.272z",
  fill: "#CBE0F1",
  fillOpacity: 0.27
}))), /*#__PURE__*/React.createElement("rect", {
  x: 0.856,
  y: 6.652,
  width: 51.257,
  height: 51.257,
  rx: 25.628,
  stroke: "#C2E0FF",
  strokeOpacity: 0.2,
  strokeWidth: 0.38
}));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#profiles-metric_svg__clip1_10117_30093)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 64.712,
  y: 0.008,
  width: 64.546,
  height: 64.546,
  rx: 32.273,
  fill: "url(#profiles-metric_svg__pattern0)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#272D33",
  d: "M64.712.008h64.546v64.546H64.712z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M110.432 24.213c0 7.426-6.021 13.447-13.447 13.447-7.427 0-13.447-6.02-13.447-13.447s6.02-13.447 13.447-13.447c7.426 0 13.447 6.02 13.447 13.447zM75.47 64.553c0-11.882 9.632-21.515 21.515-21.515 11.882 0 21.515 9.633 21.515 21.516H75.47z",
  fill: "#CBE0F1",
  fillOpacity: 0.27
}));

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 64.949,
  y: 0.245,
  width: 64.071,
  height: 64.071,
  rx: 32.035,
  stroke: "#C2E0FF",
  strokeOpacity: 0.2,
  strokeWidth: 0.475
});

var _ref4 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.8
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#profiles-metric_svg__clip2_10117_30093)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 141.667,
  y: 6.462,
  width: 51.636,
  height: 51.636,
  rx: 25.818,
  fill: "#181C20"
}), /*#__PURE__*/React.createElement("g", {
  opacity: 0.5
}, /*#__PURE__*/React.createElement("path", {
  fill: "#272D33",
  d: "M141.667 6.462h51.636v51.636h-51.636z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M178.242 25.826c0 5.941-4.816 10.758-10.757 10.758-5.942 0-10.758-4.817-10.758-10.758 0-5.941 4.816-10.758 10.758-10.758 5.941 0 10.757 4.817 10.757 10.758zM150.272 58.099c0-9.506 7.707-17.212 17.213-17.212s17.212 7.706 17.212 17.212h-34.425z",
  fill: "#CBE0F1",
  fillOpacity: 0.27
}))), /*#__PURE__*/React.createElement("rect", {
  x: 141.856,
  y: 6.652,
  width: 51.257,
  height: 51.257,
  rx: 25.628,
  stroke: "#C2E0FF",
  strokeOpacity: 0.2,
  strokeWidth: 0.38
}));

var _ref5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "profiles-metric_svg__clip0_10117_30093"
}, /*#__PURE__*/React.createElement("rect", {
  x: 0.667,
  y: 6.462,
  width: 51.636,
  height: 51.636,
  rx: 25.818,
  fill: "#fff"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "profiles-metric_svg__clip1_10117_30093"
}, /*#__PURE__*/React.createElement("rect", {
  x: 64.712,
  y: 0.008,
  width: 64.546,
  height: 64.546,
  rx: 32.273,
  fill: "#fff"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "profiles-metric_svg__clip2_10117_30093"
}, /*#__PURE__*/React.createElement("rect", {
  x: 141.667,
  y: 6.462,
  width: 51.636,
  height: 51.636,
  rx: 25.818,
  fill: "#fff"
})), /*#__PURE__*/React.createElement("pattern", {
  id: "profiles-metric_svg__pattern0",
  patternContentUnits: "objectBoundingBox",
  width: 1,
  height: 1
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#profiles-metric_svg__image0_10117_30093",
  transform: "scale(.00098)"
})));

var SvgProfilesMetric = function SvgProfilesMetric(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 194,
    height: 65,
    viewBox: "0 0 194 65",
    fill: "none"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5);
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTk0IiBoZWlnaHQ9IjY1IiB2aWV3Qm94PSIwIDAgMTk0IDY1IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIj4KPGcgb3BhY2l0eT0iMC44Ij4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzEwMTE3XzMwMDkzKSI+CjxyZWN0IHg9IjAuNjY2NTA0IiB5PSI2LjQ2MTkxIiB3aWR0aD0iNTEuNjM2NCIgaGVpZ2h0PSI1MS42MzY0IiByeD0iMjUuODE4MiIgZmlsbD0iIzE4MUMyMCIvPgo8ZyBvcGFjaXR5PSIwLjUiPgo8cmVjdCB3aWR0aD0iNTEuNjM2NCIgaGVpZ2h0PSI1MS42MzY0IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwLjY2NjUwNCA2LjQ2MTkxKSIgZmlsbD0iIzI3MkQzMyIvPgo8cGF0aCBkPSJNMzcuMjQyMiAyNS44MjU5QzM3LjI0MjIgMzEuNzY3MiAzMi40MjU4IDM2LjU4MzUgMjYuNDg0NiAzNi41ODM1QzIwLjU0MzMgMzYuNTgzNSAxNS43MjcgMzEuNzY3MiAxNS43MjcgMjUuODI1OUMxNS43MjcgMTkuODg0NyAyMC41NDMzIDE1LjA2ODQgMjYuNDg0NiAxNS4wNjg0QzMyLjQyNTggMTUuMDY4NCAzNy4yNDIyIDE5Ljg4NDcgMzcuMjQyMiAyNS44MjU5WiIgZmlsbD0iI0NCRTBGMSIgZmlsbC1vcGFjaXR5PSIwLjI3Ii8+CjxwYXRoIGQ9Ik05LjI3MjQ2IDU4LjA5ODdDOS4yNzI0NiA0OC41OTI3IDE2Ljk3ODYgNDAuODg2NSAyNi40ODQ2IDQwLjg4NjVDMzUuOTkwNiA0MC44ODY1IDQzLjY5NjcgNDguNTkyNyA0My42OTY3IDU4LjA5ODdIOS4yNzI0NloiIGZpbGw9IiNDQkUwRjEiIGZpbGwtb3BhY2l0eT0iMC4yNyIvPgo8L2c+CjwvZz4KPHJlY3QgeD0iMC44NTYzNDMiIHk9IjYuNjUxNzUiIHdpZHRoPSI1MS4yNTY3IiBoZWlnaHQ9IjUxLjI1NjciIHJ4PSIyNS42MjgzIiBzdHJva2U9IiNDMkUwRkYiIHN0cm9rZS1vcGFjaXR5PSIwLjIiIHN0cm9rZS13aWR0aD0iMC4zNzk2NzkiLz4KPC9nPgo8ZyBjbGlwLXBhdGg9InVybCgjY2xpcDFfMTAxMTdfMzAwOTMpIj4KPHJlY3QgeD0iNjQuNzExOSIgeT0iMC4wMDc4MTI1IiB3aWR0aD0iNjQuNTQ1NSIgaGVpZ2h0PSI2NC41NDU1IiByeD0iMzIuMjcyNyIgZmlsbD0idXJsKCNwYXR0ZXJuMCkiLz4KPHJlY3Qgd2lkdGg9IjY0LjU0NTUiIGhlaWdodD0iNjQuNTQ1NSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNjQuNzExOSAwLjAwNzgxMjUpIiBmaWxsPSIjMjcyRDMzIi8+CjxwYXRoIGQ9Ik0xMTAuNDMyIDI0LjIxMjZDMTEwLjQzMiAzMS42MzkyIDEwNC40MTEgMzcuNjU5NiA5Ni45ODQ5IDM3LjY1OTZDODkuNTU4MyAzNy42NTk2IDgzLjUzNzkgMzEuNjM5MiA4My41Mzc5IDI0LjIxMjZDODMuNTM3OSAxNi43ODYgODkuNTU4MyAxMC43NjU2IDk2Ljk4NDkgMTAuNzY1NkMxMDQuNDExIDEwLjc2NTYgMTEwLjQzMiAxNi43ODYgMTEwLjQzMiAyNC4yMTI2WiIgZmlsbD0iI0NCRTBGMSIgZmlsbC1vcGFjaXR5PSIwLjI3Ii8+CjxwYXRoIGQ9Ik03NS40Njk3IDY0LjU1MzVDNzUuNDY5NyA1Mi42NzEgODUuMTAyNCA0My4wMzg0IDk2Ljk4NDkgNDMuMDM4NEMxMDguODY3IDQzLjAzODQgMTE4LjUgNTIuNjcxIDExOC41IDY0LjU1MzVINzUuNDY5N1oiIGZpbGw9IiNDQkUwRjEiIGZpbGwtb3BhY2l0eT0iMC4yNyIvPgo8L2c+CjxyZWN0IHg9IjY0Ljk0OTIiIHk9IjAuMjQ1MTEyIiB3aWR0aD0iNjQuMDcwOSIgaGVpZ2h0PSI2NC4wNzA5IiByeD0iMzIuMDM1NCIgc3Ryb2tlPSIjQzJFMEZGIiBzdHJva2Utb3BhY2l0eT0iMC4yIiBzdHJva2Utd2lkdGg9IjAuNDc0NTk5Ii8+CjxnIG9wYWNpdHk9IjAuOCI+CjxnIGNsaXAtcGF0aD0idXJsKCNjbGlwMl8xMDExN18zMDA5MykiPgo8cmVjdCB4PSIxNDEuNjY3IiB5PSI2LjQ2MTkxIiB3aWR0aD0iNTEuNjM2NCIgaGVpZ2h0PSI1MS42MzY0IiByeD0iMjUuODE4MiIgZmlsbD0iIzE4MUMyMCIvPgo8ZyBvcGFjaXR5PSIwLjUiPgo8cmVjdCB3aWR0aD0iNTEuNjM2NCIgaGVpZ2h0PSI1MS42MzY0IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxNDEuNjY3IDYuNDYxOTEpIiBmaWxsPSIjMjcyRDMzIi8+CjxwYXRoIGQ9Ik0xNzguMjQyIDI1LjgyNTlDMTc4LjI0MiAzMS43NjcyIDE3My40MjYgMzYuNTgzNSAxNjcuNDg1IDM2LjU4MzVDMTYxLjU0MyAzNi41ODM1IDE1Ni43MjcgMzEuNzY3MiAxNTYuNzI3IDI1LjgyNTlDMTU2LjcyNyAxOS44ODQ3IDE2MS41NDMgMTUuMDY4NCAxNjcuNDg1IDE1LjA2ODRDMTczLjQyNiAxNS4wNjg0IDE3OC4yNDIgMTkuODg0NyAxNzguMjQyIDI1LjgyNTlaIiBmaWxsPSIjQ0JFMEYxIiBmaWxsLW9wYWNpdHk9IjAuMjciLz4KPHBhdGggZD0iTTE1MC4yNzIgNTguMDk4N0MxNTAuMjcyIDQ4LjU5MjcgMTU3Ljk3OSA0MC44ODY1IDE2Ny40ODUgNDAuODg2NUMxNzYuOTkxIDQwLjg4NjUgMTg0LjY5NyA0OC41OTI3IDE4NC42OTcgNTguMDk4N0gxNTAuMjcyWiIgZmlsbD0iI0NCRTBGMSIgZmlsbC1vcGFjaXR5PSIwLjI3Ii8+CjwvZz4KPC9nPgo8cmVjdCB4PSIxNDEuODU2IiB5PSI2LjY1MTc1IiB3aWR0aD0iNTEuMjU2NyIgaGVpZ2h0PSI1MS4yNTY3IiByeD0iMjUuNjI4MyIgc3Ryb2tlPSIjQzJFMEZGIiBzdHJva2Utb3BhY2l0eT0iMC4yIiBzdHJva2Utd2lkdGg9IjAuMzc5Njc5Ii8+CjwvZz4KPGRlZnM+CjxwYXR0ZXJuIGlkPSJwYXR0ZXJuMCIgcGF0dGVybkNvbnRlbnRVbml0cz0ib2JqZWN0Qm91bmRpbmdCb3giIHdpZHRoPSIxIiBoZWlnaHQ9IjEiPgo8dXNlIHhsaW5rOmhyZWY9IiNpbWFnZTBfMTAxMTdfMzAwOTMiIHRyYW5zZm9ybT0ic2NhbGUoMC4wMDA5NzY1NjIpIi8+CjwvcGF0dGVybj4KPGNsaXBQYXRoIGlkPSJjbGlwMF8xMDExN18zMDA5MyI+CjxyZWN0IHg9IjAuNjY2NTA0IiB5PSI2LjQ2MTkxIiB3aWR0aD0iNTEuNjM2NCIgaGVpZ2h0PSI1MS42MzY0IiByeD0iMjUuODE4MiIgZmlsbD0id2hpdGUiLz4KPC9jbGlwUGF0aD4KPGNsaXBQYXRoIGlkPSJjbGlwMV8xMDExN18zMDA5MyI+CjxyZWN0IHg9IjY0LjcxMTkiIHk9IjAuMDA3ODEyNSIgd2lkdGg9IjY0LjU0NTUiIGhlaWdodD0iNjQuNTQ1NSIgcng9IjMyLjI3MjciIGZpbGw9IndoaXRlIi8+CjwvY2xpcFBhdGg+CjxjbGlwUGF0aCBpZD0iY2xpcDJfMTAxMTdfMzAwOTMiPgo8cmVjdCB4PSIxNDEuNjY3IiB5PSI2LjQ2MTkxIiB3aWR0aD0iNTEuNjM2NCIgaGVpZ2h0PSI1MS42MzY0IiByeD0iMjUuODE4MiIgZmlsbD0id2hpdGUiLz4KPC9jbGlwUGF0aD4KPC9kZWZzPgo8L3N2Zz4=";
export { SvgProfilesMetric as ReactComponent };